import React from 'react';
import { ImportCustomColumn } from '../../../../types/importCustomColumn';

interface ImportTableBodyProps {
  table: any;
  noDataMessage?: string;
}

const ImportProductsBody: React.FC<ImportTableBodyProps> = ({
  table,
  noDataMessage,
}) => {
  const { getTableBodyProps, page, prepareRow, columns } = table;

  // Campos que deben llevar símbolo de dólar
  const moneyFields = [
    'amount',
    'freight',
    'insurance',
    'fauca',
    'others',
    'totalCost',
    'initialCost',
    'unitCostWithExtras',
  ];

  // Campos que deben mostrar porcentaje
  const percentageFields = ['percentage'];

  return (
    <tbody {...getTableBodyProps()}>
      {page.length > 0 ? (
        page.map((row: any) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps({
                key: row.original.id ?? row.id, // ✅ key único basado en `id`
              })}
              className="dark:border-gray-700 hover:bg-gray-50 transition dark:hover:bg-graydark/40"
            >
              {row.cells.map((cell: any) => {
                const column = cell.column as ImportCustomColumn<object>;
                const isMoney = moneyFields.includes(column.id || '');
                const isPercentage = percentageFields.includes(column.id || '');

                return (
                  <td
                    {...cell.getCellProps()}
                    className="text-gray-900 dark:text-gray-200 px-4 py-5 text-[15px] leading-normal whitespace-pre-line break-words"
                  >
                    {column.customCell
                      ? column.customCell(cell)
                      : isMoney
                      ? `$${Number(cell.value).toFixed(2)}`
                      : isPercentage
                      ? `${Number(cell.value).toFixed(2)}%`
                      : cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={columns.length}
            className="text-gray-600 dark:text-gray-300 dark:border-gray-700 border-b py-4 text-center"
          >
            {noDataMessage || 'No hay datos disponibles.'}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default ImportProductsBody;
